/* tslint:disable */
/* eslint-disable */
/* @relayHash e337fed48a0ebc48295caf3d434056f7 */

import { ConcreteRequest } from "relay-runtime";
export type SetUsernameInput = {
    username: string;
    clientMutationId: string;
};
export type SetUsernameMutationVariables = {
    input: SetUsernameInput;
};
export type SetUsernameMutationResponse = {
    readonly setUsername: {
        readonly user: {
            readonly username: string | null;
        };
        readonly clientMutationId: string;
    };
};
export type SetUsernameMutation = {
    readonly response: SetUsernameMutationResponse;
    readonly variables: SetUsernameMutationVariables;
};



/*
mutation SetUsernameMutation(
  $input: SetUsernameInput!
) {
  setUsername(input: $input) {
    user {
      username
      id
    }
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v2 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
    } as any), v3 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
    } as any);
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "SetUsernameMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SetUsernamePayload",
                    "kind": "LinkedField",
                    "name": "setUsername",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/)
                            ],
                            "storageKey": null
                        },
                        (v3 /*: any*/)
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "SetUsernameMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SetUsernamePayload",
                    "kind": "LinkedField",
                    "name": "setUsername",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "id",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        (v3 /*: any*/)
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "id": "e337fed48a0ebc48295caf3d434056f7",
            "metadata": {},
            "name": "SetUsernameMutation",
            "operationKind": "mutation",
            "text": null
        }
    } as any;
})();
(node as any).hash = '56444e0788d0cd2cd3d0ba824525f3b2';
export default node;
